// constant addition
export default Object.freeze({
    ...process.env,
    SAMPLE_TEST: '',

    // START skp.framework.core.consts.IConstants.java
    /**
     * Login처리시 validation 체크에 따른 결과 코드값
     */
    LOGIN_STATUS_SUCCESS:           "0",    //로그인 성공
    LOGIN_STATUS_LIMITED_TIME:      "1",    //sso로그인시간 초과
    LOGIN_STATUS_NOREGISTER:        "2",    //미등록된 사용자
    /*
    LOGIN_STATUS_NOPLEDGE:          "3",    //보안서약서 미작성자
    */
    LOGIN_STATUS_RESTING_ID:        "4",    //휴면ID
    LOGIN_STATUS_DISAPPROVAL:       "5",    //기타부서인 경우 접근불가
    LOGIN_STATUS_WRONG_PWD:         "6",    //패스워드가 틀린경우
    LOGIN_STATUS_INVALID_STATUS:    "7",    //Login Status가 New(1),Deleted(4) 또는 만료일이 지난 Temp(2)인 경우
    
    /**
     * LOGIN_COMMONLOGIN(인증가능 FLAG) : MVOC_LOGINUSER
     */
    LOGIN_COMMONLOGIN_CD1:          "0",    //로그인 불가능
    LOGIN_COMMONLOGIN_CD2:          "1",    //로그인 가능
    
    /**
     * INCUMBENT(재직여부) : MVOC_LOGINUSER
     */
    INCUMBENT_CD1:                  "0",    //미재직(퇴사,휴직...)
    INCUMBENT_CD2:                  "1",    //재직
    
    /**
     * REQ_TYPE(요청구분) : MVOC_USERREQ
     */
    REQ_TYPE_CD1:                   "0",    //사용권한요청
    REQ_TYPE_CD2:                   "1",    //휴면계정요청
    
    /**
     * YESNO여부 : 모든 Y/N공통코드
     */
    COMMON_CD_YES:                  "Y",
    COMMON_CD_NO:                   "N",
    
    /**
     * 분기 / 월 / 주 / 일
     */
    PERIOD_QUATERLY:                "Q",
    PERIOD_MONTHLY:                 "M",
    PERIOD_WEEKLY:                  "W",
    PERIOD_DAILY:                   "D",
    // END skp.framework.core.consts.IConstants.java

    // START skp.basis.common.CommonRoleCd.java
    SYSTEM_ADMIN:                   "9900",
    
    GBM_ADMIN:                      "4900",
    GBM_DEFAULT:                    "4800",
    
    RHQ_ADMIN:                      "3900",
    RHQ_DEFAULT:                    "3800",
    
    TECH_SUPPORT:                   "2700",
    SUB_ADMIN:                      "2900",
    SUB_DEFAULT:                    "2800",
    
    ASC_DEFAULT:                    "1800",
    AGENT_DEFAULT:                  "1900",

    ENV_ADMIN:                      "2200", //  Environment admin
    // END skp.basis.common.CommonRoleCd.java

    // START skp.basis.common.CommonWorkCd.java
    //공지사항
    NOTICE_CD:                      "01",
    
    //Q&A 
    QUE_AND_ANS_CD:                 "10",   //Q&A Question 
    QUESTION_CD:                    "11",   //
    PRO_ANSWER_CD:                  "12",   //전문가 답변
    GER_ANSWER_CD:                  "13",   //일반 답변
    SYMPTOM_CD:                     "16",   //증상
    FAULT_CD:                       "17",   //결함
    
    //Knowledge
    KNOWLEDGE_CD:                   "20",
    KNOWLEDGE_IMAGE_CD:             "24",
    
    PRODUCT_INFOMATION_CD:          "21",
    PRODUCT_SOFT_CD:                "22",
    QUICK_TIPS_CD:                  "23",
    REFERENCE_KNOWLEDGE_CD:         "25",
    TRAINING__CD:                   "26",
    SALES_MARKETING_CD:             "27",
    OTHER_CD:                       "28",

    // Knowledge Recommend Code
    RECOMMEND_CD:                   "29",
    
    
    // G-Community
    G_COMMUNITY:                    "30",
    G_COMMUNITY_REPLY:              "31",
    
    MILEAGE_K_REG:                  "01",
    MILEAGE_K_READ:                 "02",
    MILEAGE_K_READED:               "03",
    MILEAGE_K_SATIS:                "04",
    MILEAGE_Q_REG:                  "05",
    MILEAGE_Q_AND:                  "06",
    
    
    BBS_CD:                         "40",
    BBS_IMAGE_CD:                   "41",
    
    FAQ_CD:                         "51",
    // END skp.basis.common.CommonWorkCd.java


    // START skp.basis.common.CommonLoginWorkCd.java
    LOGIN_SYS_GSPN:                 "GSPN",
    LOGIN_SYS_SUPPORT:              "SUPPORT",
    
    /*
    LOGIN_SYS_CS_KNOWLEDGE:         "GSPN_KNOWLEDGE",
    */
    
    LOGIN_SYS_SCMS:                 "SCMS",
    LOGIN_SYS_CS:                   "CS",
    
    //로그인 시스템 정보
    LOGIN_SYS_APPROVAL_GSPN:        "VLDPS",
    LOGIN_SYS_APPROVAL_SUPPORT:     "SUPPORT",
    
    /*
    LOGIN_SYS_CS_KNOWLEDGE:         "GSPN_KNOWLEDGE",
    */
    
    LOGIN_SYS_APPROVAL_SCMS:        "SCMS",
    LOGIN_SYS_APPROVAL_CS:          "WLDPTM",
    
    /**
     * 시스템 메뉴 유형 
     */
    SYSTEM_MENU_TYPE_FULL:          "1", //상위 메뉴 모두 존재함
    SYSTEM_MENU_TYPE_NON_SEARCH:    "2", //상위 메뉴는 있고 검색이 없음
    SYSTEM_MENU_TYPE_NON_TOP:       "3", //상위 메뉴 없는 부분
    
    /**
     * 로딩된 메뉴 정보 
     */
    SYSTEM_LOAD_MENU_ALL:           "ALL", //
    SYSTEM_LOAD_MENU_SUP:           "SUP", //
    SYSTEM_LOAD_MENU_QNA:           "QNA", //
    SYSTEM_LOAD_MENU_ADM:           "ADM", //
    // END skp.basis.common.CommonLoginWorkCd.java
});



// WEBPACK FOOTER //
// ./src/constants/index.js